import { Box, Collapse, Divider, Grid, List, ListItemButton, ListItemText, Paper, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useLocationWeatherContext } from "../contexts/LocationWeatherContext";
import { DAY_NIGHT_TEXT_COLOR, SECONDARY_GRAY_COLOR, weatherCodes } from "../types/Weather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getDateAndDayOfWeek, getDateOnlyString } from "../helpers/weather-helpers";
import WeatherCurrentDetailsSection from "./WeatherCurrentDetailsSection";
import HourlyWeatherSlider from "./HourlyWeatherSlider";
import { faHourglass } from "@fortawesome/free-solid-svg-icons";

const SevenDaysWeather = () => {

  const { weather, currentWeather, hourlyWeatherMap, hourlyWeatherUnit, dailyWeatherMap, dailyWeatherUnit, isLoading } = useLocationWeatherContext();
  const [dailyWeatherTimes, setdailyWeatherTimesOpenClose] = useState<Map<string, boolean>>(new Map());

  useEffect(() => {
    let openCloseRows = new Map<string, boolean>();
    weather?.daily.time.forEach((eachTime) => {
      openCloseRows.set(eachTime, false);
    });
    setdailyWeatherTimesOpenClose(openCloseRows);
  }, [weather]);

  const handleClick = (time: string) => {
    dailyWeatherTimes.set(time, !dailyWeatherTimes.get(time));
    setdailyWeatherTimesOpenClose(new Map(dailyWeatherTimes));
  };

  const currentDateOnlyStr = useMemo(() => {
    return getDateOnlyString(currentWeather?.time);
  }, [currentWeather?.time]);


  return (
    <Box sx={{
      color: DAY_NIGHT_TEXT_COLOR,
      backgroundColor: '#2554C7',
      borderRadius: '16px',
    }}>
      <List
        sx={{ width: '100%' }}
        component="nav"
      >
        {
          Array.from(dailyWeatherTimes.keys()).map((eachTime) => {
            const dailyWeather = dailyWeatherMap.get(eachTime);
            const hourlyWeather = hourlyWeatherMap.get(eachTime);

            const weatherCode = weatherCodes.get(dailyWeather?.weathercode!);

            return (
              <Box key={eachTime}>
                <ListItemButton onClick={() => handleClick(eachTime)}>
                  <ListItemText primary={
                    <Box >
                      <Typography>{eachTime === currentDateOnlyStr ? 'Today' : getDateAndDayOfWeek(eachTime)}</Typography>
                      <Typography color={SECONDARY_GRAY_COLOR}>{weatherCode?.text}</Typography>
                    </Box>
                  } />
                  <Box>
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={6} >
                        <FontAwesomeIcon
                          icon={weatherCode?.dayIcon ?? faHourglass}
                          size="2x" />
                      </Grid>
                      <Grid item xs={6} >
                        <Typography sx={{ width: '4ch' }}>{dailyWeather?.temperature_2m_max.toFixed(0)}°</Typography>
                        <Typography sx={{ width: '4ch' }} color={SECONDARY_GRAY_COLOR}>{dailyWeather?.temperature_2m_min.toFixed(0)}°</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </ListItemButton>
                <Divider />
                <Collapse in={dailyWeatherTimes.get(eachTime)} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemText primary={
                      <>
                        <Box sx={{ paddingTop: 2 }} />
                        < Paper sx={{
                          borderRadius: '16px',
                          marginX: 2,
                          padding: 2,
                          backgroundColor: DAY_NIGHT_TEXT_COLOR,
                          opacity: 0.85,
                        }}>
                          <WeatherCurrentDetailsSection
                            dailyWeather={dailyWeather!}
                            dailyWeatherUnit={dailyWeatherUnit!}
                            hourlyWeather={hourlyWeather!}
                            hourlyWeatherUnit={hourlyWeatherUnit!}
                            headerText=""
                            disablePadding
                          />
                        </Paper>
                        <HourlyWeatherSlider hourlyWeather={hourlyWeather!} />
                        <Divider></Divider>
                      </>
                    } />
                  </List>
                </Collapse>
              </Box>
            );
          })
        }
      </List>
    </Box>
  );
}

export default SevenDaysWeather;